import img from "../assests/images/white-logo.png";
import { Link } from "react-router-dom";
import {
  ArrowRightIcon,
  CheckIcon,
  EnvelopeIcon,
  MapPinIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-[#0B5552] text-[#FBFAF6]">

      {/* =========================================================
          AMBIENT BACKGROUND
      ========================================================== */}

      {/* Top Red Glow */}
      {/* <div
        className="
          pointer-events-none
          absolute
          inset-x-0
          top-0
          h-[180px]
          bg-gradient-to-b
          from-[#8B0000]/45
          via-[#8B0000]/15
          to-transparent
        "
      /> */}

      {/* Bottom Red Glow */}
      {/* <div
        className="
          pointer-events-none
          absolute
          inset-x-0
          bottom-0
          h-[220px]
          bg-gradient-to-t
          from-[#8B0000]/30
          via-[#8B0000]/10
          to-transparent
        "
      /> */}

      {/* Gold Glow */}
      <div
        className="
          pointer-events-none
          absolute
          -left-40
          top-1/3
          h-[420px]
          w-[420px]
          rounded-full
          bg-[#D7A74A]/10
          blur-[120px]
        "
      />

      {/* Teal Glow */}
      <div
        className="
          pointer-events-none
          absolute
          -right-40
          bottom-20
          h-[500px]
          w-[500px]
          rounded-full
          bg-[#062F3A]/60
          blur-[120px]
        "
      />

      {/* Decorative Rings */}
      <div
        className="
          pointer-events-none
          absolute
          -right-28
          -top-28
          h-80
          w-80
          rounded-full
          border
          border-[#D7A74A]/15
        "
      />

      <div
        className="
          pointer-events-none
          absolute
          -right-10
          -top-10
          h-56
          w-56
          rounded-full
          border
          border-[#D7A74A]/10
        "
      />


      {/* =========================================================
          TOP GOLD LINE
      ========================================================== */}

      <div
        className="
          relative
          z-10
          h-px
          w-full
          bg-gradient-to-r
          from-transparent
          via-[#D7A74A]
          to-transparent
        "
      />


      <div className="relative z-10 mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">


        {/* =========================================================
            PREMIUM FOOTER INTRO
        ========================================================== */}

        <div
          className="
            border-b
            border-white/10
            py-12
            sm:py-14
            lg:py-16
          "
        >

          <div
            className="
              flex
              flex-col
              gap-8
              lg:flex-row
              lg:items-end
              lg:justify-between
            "
          >

            {/* Brand */}
            <div>

              <Link
                to="/"
                className="
                  inline-flex
                  items-center
                  transition-transform
                  duration-300
                  hover:scale-[1.02]
                "
              >
                <img
                  src={img}
                  alt="Dubai Hotel Rates"
                  className="
                    block
                    h-auto
                    w-[145px]
                    object-contain
                    sm:w-[165px]
                    lg:w-[185px]
                  "
                />
              </Link>


              <div className="mt-5 flex items-center gap-3">

                <span className="h-px w-10 bg-[#D7A74A]" />

                <span
                  className="
                    text-[10px]
                    font-semibold
                    uppercase
                    tracking-[0.3em]
                    text-[#D7A74A]
                  "
                >
                  Stay Better. Choose Better.
                </span>

              </div>

            </div>


            {/* Intro Message */}
            <div className="max-w-xl lg:text-right">

              <p
                className="
                  font-serif
                  text-2xl
                  leading-tight
                  text-white
                  sm:text-3xl
                "
              >
                Your next Dubai stay
                <span className="text-[#D7A74A]">
                  {" "}starts here.
                </span>
              </p>

              <p className="mt-3 text-sm leading-7 text-white/55">
                Compare beautiful hotels, discover better rates, and
                book your Dubai experience with confidence.
              </p>

            </div>

          </div>

        </div>


        {/* =========================================================
            MAIN FOOTER
        ========================================================== */}

        <div
          className="
            grid
            gap-12
            py-14
            sm:py-16
            lg:grid-cols-12
            lg:gap-10
            lg:py-20
          "
        >


          {/* =======================================================
              BRAND / ABOUT
          ======================================================== */}

          <div className="lg:col-span-4">

            <p
              className="
                max-w-md
                text-sm
                leading-7
                text-white/60
              "
            >
              Discover exceptional hotels across Dubai, compare
              rates with confidence, and find a stay that makes
              your Dubai experience unforgettable.
            </p>


            {/* Trust Card */}
            <div
              className="
                mt-7
                max-w-md
                rounded-2xl
                border
                border-white/10
                bg-white/[0.04]
                p-5
                backdrop-blur-sm
              "
            >

              <div className="flex items-start gap-4">

                <div
                  className="
                    flex
                    h-10
                    w-10
                    shrink-0
                    items-center
                    justify-center
                    rounded-full
                    bg-[#D7A74A]/10
                    text-[#D7A74A]
                  "
                >
                  <CheckIcon className="h-5 w-5" />
                </div>

                <div>

                  <p className="text-sm font-semibold text-white">
                    Book with confidence
                  </p>

                  <p className="mt-1 text-xs leading-5 text-white/50">
                    Better hotel choices, transparent rates and
                    a simple booking experience.
                  </p>

                </div>

              </div>

            </div>


            {/* Social */}
            <div className="mt-7 flex items-center gap-3">

              {/* Facebook */}
              <a
                href="https://www.facebook.com/SouthTravelsUAE/"
                aria-label="Facebook"
                className="
                  flex
                  h-10
                  w-10
                  items-center
                  justify-center
                  rounded-full
                  border
                  border-white/15
                  text-white/65
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:border-[#D7A74A]
                  hover:bg-[#D7A74A]
                  hover:text-[#0B5552]
                "
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4"
                >
                  <path d="M14 8h3V4h-3c-3.31 0-5 1.69-5 5v3H6v4h3v8h4v-8h3l1-4h-4V9c0-.69.31-1 1-1Z" />
                </svg>
              </a>


              {/* Instagram */}
              <a
                href="https://www.instagram.com/southtravels_dmcc/"
                aria-label="Instagram"
                className="
                  flex
                  h-10
                  w-10
                  items-center
                  justify-center
                  rounded-full
                  border
                  border-white/15
                  text-white/65
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:border-[#D7A74A]
                  hover:bg-[#D7A74A]
                  hover:text-[#0B5552]
                "
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  className="h-4 w-4"
                >
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="5"
                  />
                  <circle cx="12" cy="12" r="4" />
                  <circle
                    cx="17.5"
                    cy="6.5"
                    r="1"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
              </a>


              {/* X */}
              <a
                href="https://x.com/SouthTravels"
                aria-label="X"
                className="
                  flex
                  h-10
                  w-10
                  items-center
                  justify-center
                  rounded-full
                  border
                  border-white/15
                  text-white/65
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:border-[#D7A74A]
                  hover:bg-[#D7A74A]
                  hover:text-[#0B5552]
                "
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817-5.965 6.817H1.682l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
                </svg>
              </a>


              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/company/southtravelsuae/"
                aria-label="LinkedIn"
                className="
                  flex
                  h-10
                  w-10
                  items-center
                  justify-center
                  rounded-full
                  border
                  border-white/15
                  text-white/65
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:border-[#D7A74A]
                  hover:bg-[#D7A74A]
                  hover:text-[#0B5552]
                "
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4"
                >
                  <path d="M5.04 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM3 9h4v12H3V9Zm6 0h3.83v1.64h.05c.53-1 1.83-2.06 3.77-2.06 4.03 0 4.77 2.65 4.77 6.1V21h-4v-5.6c0-1.34-.02-3.06-1.87-3.06-1.87 0-2.16 1.46-2.16 2.96V21H9V9Z" />
                </svg>
              </a>

            </div>

          </div>


          {/* =======================================================
              EXPLORE
          ======================================================== */}

          <div className="lg:col-span-2 lg:col-start-6">

            <FooterTitle title="Explore" />

            <ul className="mt-6 space-y-3.5">

              <FooterLink to="/hotels">
                Dubai Hotels
              </FooterLink>



              <FooterLink to="/hotels">
                Compare Rates
              </FooterLink>

              <FooterLink to="/hotels">
                Luxury Hotels
              </FooterLink>

              <FooterLink to="/hotels">
                Beachfront Hotels
              </FooterLink>

            </ul>

          </div>


          {/* =======================================================
              COMPANY
          ======================================================== */}

          <div className="lg:col-span-2">

            <FooterTitle title="Company" />

            <ul className="mt-6 space-y-3.5">

              <FooterLink to="/about-us">
                About Us
              </FooterLink>

              <FooterLink to="/contact-us">
                Contact Us
              </FooterLink>

              <FooterLink to="/contact-us">
                Help Center
              </FooterLink>





            </ul>

          </div>


          {/* =======================================================
              CONTACT
          ======================================================== */}

          <div className="lg:col-span-3">

            <FooterTitle title="Contact Us" />

            <div className="mt-6 space-y-4">


              {/* Phone */}
              <a
                href="tel:+971502477593"
                className="
                  group
                  flex
                  items-center
                  gap-4
                  rounded-xl
                  border
                  border-white/10
                  bg-white/[0.03]
                  p-4
                  transition-all
                  duration-300
                  hover:border-[#D7A74A]/40
                  hover:bg-white/[0.06]
                "
              >

                <span
                  className="
                    flex
                    h-10
                    w-10
                    shrink-0
                    items-center
                    justify-center
                    rounded-full
                    bg-[#D7A74A]/10
                    text-[#D7A74A]
                    transition-colors
                    group-hover:bg-[#D7A74A]
                    group-hover:text-[#0B5552]
                  "
                >
                  <PhoneIcon className="h-4 w-4" />
                </span>

                <span>

                  <span
                    className="
                      block
                      text-[9px]
                      font-semibold
                      uppercase
                      tracking-[0.2em]
                      text-white/35
                    "
                  >
                    Phone
                  </span>

                  <span
                    className="
                      mt-1
                      block
                      text-sm
                      font-medium
                      text-white/80
                      transition-colors
                      group-hover:text-[#D7A74A]
                    "
                  >
                    +971 50 247 7593
                  </span>

                </span>

              </a>


              {/* Email */}
              <a
                href="mailto:info@southtravels.com"
                className="
                  group
                  flex
                  items-center
                  gap-4
                  rounded-xl
                  border
                  border-white/10
                  bg-white/[0.03]
                  p-4
                  transition-all
                  duration-300
                  hover:border-[#D7A74A]/40
                  hover:bg-white/[0.06]
                "
              >

                <span
                  className="
                    flex
                    h-10
                    w-10
                    shrink-0
                    items-center
                    justify-center
                    rounded-full
                    bg-[#D7A74A]/10
                    text-[#D7A74A]
                    transition-colors
                    group-hover:bg-[#D7A74A]
                    group-hover:text-[#0B5552]
                  "
                >
                  <EnvelopeIcon className="h-4 w-4" />
                </span>

                <span>

                  <span
                    className="
                      block
                      text-[9px]
                      font-semibold
                      uppercase
                      tracking-[0.2em]
                      text-white/35
                    "
                  >
                    Email
                  </span>

                  <span
                    className="
                      mt-1
                      block
                      text-sm
                      font-medium
                      text-white/80
                      transition-colors
                      group-hover:text-[#D7A74A]
                    "
                  >
                    info@southtravels.com
                  </span>

                </span>

              </a>


              {/* Location */}
              <div
                className="
                  flex
                  items-center
                  gap-4
                  rounded-xl
                  border
                  border-white/10
                  bg-white/[0.03]
                  p-4
                "
              >

                <span
                  className="
                    flex
                    h-10
                    w-10
                    shrink-0
                    items-center
                    justify-center
                    rounded-full
                    bg-[#D7A74A]/10
                    text-[#D7A74A]
                  "
                >
                  <MapPinIcon className="h-4 w-4" />
                </span>

                <span>

                  <span
                    className="
                      block
                      text-[9px]
                      font-semibold
                      uppercase
                      tracking-[0.2em]
                      text-white/35
                    "
                  >
                    Location
                  </span>

                  <span className="mt-1 block text-sm text-white/80">
                    Office 302, 3rd Flr. HDS Tower Cluster F, Jumeirah Lakes Towers Dubai
                  </span>

                </span>

              </div>

            </div>

          </div>

        </div>




        {/* =========================================================
            FOOTER BOTTOM
        ========================================================== */}

        <div className="border-t border-white/10 py-6">

          <div
            className="
              flex
              flex-col
              items-center
              justify-between
              gap-4
              text-center
              sm:flex-row
              sm:text-left
            "
          >

            <p className="text-[11px] text-white/35">
              © {currentYear} Beach Hotel Dubai. All rights reserved.
            </p>


            <div
              className="
                flex
                flex-wrap
                items-center
                justify-center
                gap-x-4
                gap-y-2
                text-[11px]
                text-white/35
              "
            >

              <Link
                to="/privacy-policy"
                className="transition-colors hover:text-[#D7A74A]"
              >
                Privacy Policy
              </Link>

              <span className="h-3 w-px bg-white/10" />

              <Link
                to="/terms-conditions"
                className="transition-colors hover:text-[#D7A74A]"
              >
                Terms & Conditions
              </Link>

              <span className="h-3 w-px bg-white/10" />

              <span className="text-[#D7A74A]">
                Dubai, UAE
              </span>

            </div>

          </div>

        </div>

      </div>
    </footer>
  );
}


/* =============================================================
   FOOTER TITLE
============================================================= */

function FooterTitle({ title }) {
  return (
    <>
      <h3
        className="
          font-serif
          text-xl
          font-medium
          text-white
        "
      >
        {title}
      </h3>

      <div className="mt-4 h-px w-8 bg-[#D7A74A]" />
    </>
  );
}


/* =============================================================
   FOOTER LINK
============================================================= */

function FooterLink({ to, children }) {
  return (
    <li>
      <Link
        to={to}
        className="
          group
          inline-flex
          items-center
          gap-2
          text-sm
          text-white/55
          transition-all
          duration-300
          hover:translate-x-1
          hover:text-[#D7A74A]
        "
      >
        <span
          className="
            h-px
            w-0
            bg-[#D7A74A]
            transition-all
            duration-300
            group-hover:w-3
          "
        />

        {children}
      </Link>
    </li>
  );
}